export enum SocialNameEnum {
  Twitter = 'twitter',
  Fb = 'fb',
  Youtube = 'youtube',
  Linkedin = 'linkedin',
}
